module.exports = __webpack_public_path__ + "img/f0abb76ab87482e72b0a4d6a58c9ed3e.png";